import { styled } from "@mui/material";
import { colorNames } from "../Theme/Colors";
const colors = colorNames();

export const PassengersWrapper = styled('div')`
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;

    .head_sec {
        position: relative;
        width: 100%;
        display: flex;
        align-items: center;
        padding: 0 15px;

        h6 {
            position: relative;
            font-size: 21px;
            font-weight: 600;
            color: ${colors.customColors.blackColor};
            font-family: "SUSE", sans-serif;
        }

        .filter_search_sec {
            position: relative;
            display: flex;
            align-items: center;
            margin-left: auto;

            .search_sec {
                position: relative;
                height: 35px;
                padding: 5px 0;
                display: flex;
                border: 1px solid ${colors.customColors.borderColor};
                border-radius: 6px;

                i {
                    position: relative;
                    width: 40px;
                    height: 100%;
                    font-size: 13px;
                    color: ${colors.customColors.blackColor3};
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-right: 1px solid ${colors.customColors.borderColor};
                }

                input {
                    position: relative;
                    width: 300px;
                    height: 100%;
                    border: none;
                    outline: none;
                    padding: 0 15px;
                    font-size: 12px;
                    color: ${colors.customColors.blackColor1};
                }
            }

            .add_btn {
                position: relative;
                margin-left: 20px;

                button {
                    position: relative;
                    padding: 0 35px;
                    height: 35px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    background: linear-gradient(45deg, ${colors.customColors.blueColor1}, ${colors.customColors.blueColor3});
                    border: none;
                    color: ${colors.customColors.whiteColor};
                    border-radius: 6px;
                    font-size: 13px;
                    font-weight: 500;
                    transition: all 0.5s ease;

                    i {
                        margin-right: 8px;
                        font-size: 12px;
                    }

                    &:hover {
                        border-radius: 25px;
                        transition: all 0.5s ease;
                    }
                }
            }
        }
    }

    .table_sec {
        position: relative;
        width: 100%;
        margin-top: 25px;
        padding:  0 15px;

        table {
            position: relative;
            width: 100%;
            display: flex;
            flex-direction: column;

            thead {
                position: relative;
                width: 100%;
                height: 40px;
                background: ${colors.themeColor};
                border-radius: 10px 10px 0px 0px;
                border: 1px solid ${colors.themeColor};

                tr {
                    position: relative;
                    width: 100%;
                    height: 100%;
                    display: flex;
                }

                th {
                    position: relative;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    font-family: "Lemonada", cursive;
                    font-size: 12px;
                    word-break: break-all;
                    color: ${colors.customColors.whiteColor};
                    padding: 0 25px;
                    font-weight: 600;

                    &:nth-of-type(1) {
                        width: 22%;
                    }

                    &:nth-of-type(2) {
                        width: 16%;
                        justify-content: center;
                    }

                    &:nth-of-type(3) {
                        width: 18%;
                        justify-content: center;
                    }

                    &:nth-of-type(4) {
                        width: 18%;
                        justify-content: center;
                    }

                    &:nth-of-type(5) {
                        width: 16%;
                        justify-content: center;
                    }

                    &:nth-of-type(6) {
                        width: 10%;
                        justify-content: center;
                    }
                }
            }

            tbody {
                position: relative;
                width: 100%;
                border: 1px solid ${colors.customColors.whiteColor2};
                border-top: none;
                border-radius: 0px 0px 10px 10px;
                display: flex;
                flex-direction: column;
                overflow: hidden;

                tr {
                    position: relative;
                    width: 100%;
                    min-height: 40px;
                    display: flex;

                    &:nth-of-type(even) {
                        background: ${colors.customColors.blueColorLight};
                    }

                    td {
                        position: relative;
                        padding: 12px 25px;
                        display: flex;
                        color: ${colors.customColors.blackColor};
                        font-size: 13px;
                        word-break: break-all;
                        line-height: 1.5;

                        &:nth-of-type(1) {
                            width: 22%;
                            display: flex;

                            .left_table_sec {
                                position: relative;
                                width: 30px;
                                height: 30px;
                                border-radius: 6px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                background: ${colors.customColors.blueColor2};
                                overflow: hidden;

                                img {
                                    width: 100%;
                                    height: 100%;
                                    object-fit: cover;
                                }

                                h5 {
                                    position: relative;
                                    font-size: 14px;
                                    font-weight: 500;
                                    color: ${colors.customColors.whiteColor};
                                    text-transform: uppercase;
                                }
                            }

                            .right_table_sec {
                                position: relative;
                                width: calc(100% - 30px);
                                padding-left: 7px;
                                display: flex;
                                flex-direction: column;

                                h6 {
                                    font-size: 13px;
                                    font-weight: 400;
                                    color: ${colors.customColors.blackColor1};
                                }

                                p {
                                    font-size: 10px;
                                    font-weight: 400;
                                    color: ${colors.customColors.blackColor2};
                                }
                            }
                        }

                        &:nth-of-type(2) {
                            width: 16%;
                            align-items: center;
                            justify-content: center;

                            .type_sec {
                                position: relative;
                                width: 100%;
                                display: flex;
                                flex-direction: column;
                                align-items: center;
                                justify-content: center;

                                h5 {
                                    font-size: 12px;
                                    font-weight: 400;
                                    color: ${colors.customColors.blackColor1};
                                }
                            }
                        }

                        &:nth-of-type(3) {
                            width: 18%;
                            align-items: center;
                            justify-content: center;
                        }

                        &:nth-of-type(4) {
                            width: 18%;
                            align-items: center;
                            justify-content: center;
                        }

                        &:nth-of-type(5) {
                            width: 16%;
                            align-items: center;
                            justify-content: center;
                        }

                        &:nth-of-type(6) {
                            width: 10%;
                            align-items: center;
                            justify-content: center;

                            a {
                                position: relative;
                                text-decoration: none;
                                cursor: pointer;
                                font-size: 13px;

                               &.edit_btn {
                                    color: ${colors.customColors.greenColor};
                                    margin-right: 10px;
                               }

                               &.delete_btn {
                                    color: ${colors.customColors.redColor};
                               }
                            }
                        }

                        &.empty_message {
                            position: relative;
                            width: 100%;
                            padding: 12px 25px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            font-size: 13px;
                            color: ${colors.customColors.blackColor2};
                        }
                    }
                }
            }
        }
    }
`;

export const VehicleWrapper = styled('div')`
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;

    .head_sec {
        position: relative;
        width: 100%;
        display: flex;
        align-items: center;
        padding: 0 15px;

        h6 {
            position: relative;
            font-size: 21px;
            font-weight: 600;
            color: ${colors.customColors.blackColor};
            font-family: "SUSE", sans-serif;
        }

        .filter_search_sec {
            position: relative;
            display: flex;
            align-items: center;
            margin-left: auto;

            .search_sec {
                position: relative;
                height: 35px;
                padding: 5px 0;
                display: flex;
                border: 1px solid ${colors.customColors.borderColor};
                border-radius: 6px;

                i {
                    position: relative;
                    width: 40px;
                    height: 100%;
                    font-size: 13px;
                    color: ${colors.customColors.blackColor3};
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-right: 1px solid ${colors.customColors.borderColor};
                }

                input {
                    position: relative;
                    width: 300px;
                    height: 100%;
                    border: none;
                    outline: none;
                    padding: 0 15px;
                    font-size: 12px;
                    color: ${colors.customColors.blackColor1};
                }
            }

            .add_btn {
                position: relative;
                margin-left: 20px;

                button {
                    position: relative;
                    padding: 0 35px;
                    height: 35px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    background: linear-gradient(45deg, ${colors.customColors.blueColor1}, ${colors.customColors.blueColor3});
                    border: none;
                    color: ${colors.customColors.whiteColor};
                    border-radius: 6px;
                    font-size: 13px;
                    font-weight: 500;
                    transition: all 0.5s ease;

                    i {
                        margin-right: 8px;
                        font-size: 12px;
                    }

                    &:hover {
                        border-radius: 25px;
                        transition: all 0.5s ease;
                    }
                }
            }
        }
    }

    .table_sec {
        position: relative;
        width: 100%;
        margin-top: 25px;
        padding:  0 15px;

        table {
            position: relative;
            width: 100%;
            display: flex;
            flex-direction: column;

            thead {
                position: relative;
                width: 100%;
                height: 40px;
                background: ${colors.themeColor};
                border-radius: 10px 10px 0px 0px;
                border: 1px solid ${colors.themeColor};

                tr {
                    position: relative;
                    width: 100%;
                    height: 100%;
                    display: flex;
                }

                th {
                    position: relative;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    font-family: "Lemonada", cursive;
                    font-size: 12px;
                    word-break: break-all;
                    color: ${colors.customColors.whiteColor};
                    padding: 0 25px;
                    font-weight: 600;

                    &:nth-of-type(1) {
                        width: 20%;
                    }

                    &:nth-of-type(2) {
                        width: 25%;
                        justify-content: center;
                    }

                    &:nth-of-type(3) {
                        width: 15%;
                        justify-content: center;
                    }

                    &:nth-of-type(4) {
                        width: 18%;
                        justify-content: center;
                    }

                    &:nth-of-type(5) {
                        width: 12%;
                        justify-content: center;
                    }

                    &:nth-of-type(6) {
                        width: 10%;
                        justify-content: center;
                    }
                }
            }

            tbody {
                position: relative;
                width: 100%;
                border: 1px solid ${colors.customColors.whiteColor2};
                border-top: none;
                border-radius: 0px 0px 10px 10px;
                display: flex;
                flex-direction: column;
                overflow: hidden;

                tr {
                    position: relative;
                    width: 100%;
                    min-height: 40px;
                    display: flex;

                    &:nth-of-type(even) {
                        background: ${colors.customColors.blueColorLight};
                    }

                    td {
                        position: relative;
                        padding: 12px 25px;
                        display: flex;
                        color: ${colors.customColors.blackColor};
                        font-size: 13px;
                        word-break: break-all;
                        line-height: 1.5;

                        &:nth-of-type(1) {
                            width: 20%;
                            display: flex;
                        }

                        &:nth-of-type(2) {
                            width: 25%;
                            align-items: center;
                            justify-content: center;
                        }

                        &:nth-of-type(3) {
                            width: 15%;
                            align-items: center;
                            justify-content: center;
                        }

                        &:nth-of-type(4) {
                            width: 18%;
                            align-items: center;
                            justify-content: center;
                        }

                        &:nth-of-type(5) {
                            width: 12%;
                            align-items: center;
                            justify-content: center;

                            p {
                                position: relative;
                                font-size: 10px;
                                font-weight: 500;
                                line-height: 1;
                                display: flex;
                                align-items: center;
                                border-radius: 20px;
                                padding: 4px 15px;
                                color: ${colors.customColors.yellowColor1};
                                background: ${colors.customColors.yellowColorLight};

                                &.active {
                                    color: ${colors.customColors.greenColor};
                                    background: ${colors.customColors.greenColorLight};
                                }
                                &.deactive {
                                    color: ${colors.customColors.redColor};
                                    background: ${colors.customColors.redColorLight};
                                }
                            }
                        }

                        &:nth-of-type(6) {
                            width: 10%;
                            align-items: center;
                            justify-content: center;

                            a {
                                position: relative;
                                text-decoration: none;
                                cursor: pointer;
                                font-size: 13px;

                               &.edit_btn {
                                    color: ${colors.customColors.greenColor};
                                    margin-right: 10px;
                               }

                               &.delete_btn {
                                    color: ${colors.customColors.redColor};
                               }
                            }
                        }

                        &.empty_message {
                            position: relative;
                            width: 100%;
                            padding: 12px 25px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            font-size: 13px;
                            color: ${colors.customColors.blackColor2};
                        }
                    }
                }
            }
        }
    }
`;

export const VehicleStaffWrapper = styled('div')`
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;

    .head_sec {
        position: relative;
        width: 100%;
        display: flex;
        align-items: center;
        padding: 0 15px;

        h6 {
            position: relative;
            font-size: 21px;
            font-weight: 600;
            color: ${colors.customColors.blackColor};
            font-family: "SUSE", sans-serif;
        }

        .filter_search_sec {
            position: relative;
            display: flex;
            align-items: center;
            margin-left: auto;

            .search_sec {
                position: relative;
                height: 35px;
                padding: 5px 0;
                display: flex;
                border: 1px solid ${colors.customColors.borderColor};
                border-radius: 6px;

                i {
                    position: relative;
                    width: 40px;
                    height: 100%;
                    font-size: 13px;
                    color: ${colors.customColors.blackColor3};
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-right: 1px solid ${colors.customColors.borderColor};
                }

                input {
                    position: relative;
                    width: 300px;
                    height: 100%;
                    border: none;
                    outline: none;
                    padding: 0 15px;
                    font-size: 12px;
                    color: ${colors.customColors.blackColor1};
                }
            }

            .add_btn {
                position: relative;
                margin-left: 20px;

                button {
                    position: relative;
                    padding: 0 35px;
                    height: 35px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    background: linear-gradient(45deg, ${colors.customColors.blueColor1}, ${colors.customColors.blueColor3});
                    border: none;
                    color: ${colors.customColors.whiteColor};
                    border-radius: 6px;
                    font-size: 13px;
                    font-weight: 500;
                    transition: all 0.5s ease;

                    i {
                        margin-right: 8px;
                        font-size: 12px;
                    }

                    &:hover {
                        border-radius: 25px;
                        transition: all 0.5s ease;
                    }
                }
            }
        }
    }

    .table_sec {
        position: relative;
        width: 100%;
        margin-top: 25px;
        padding:  0 15px;

        table {
            position: relative;
            width: 100%;
            display: flex;
            flex-direction: column;

            thead {
                position: relative;
                width: 100%;
                height: 40px;
                background: ${colors.themeColor};
                border-radius: 10px 10px 0px 0px;
                border: 1px solid ${colors.themeColor};

                tr {
                    position: relative;
                    width: 100%;
                    height: 100%;
                    display: flex;
                }

                th {
                    position: relative;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    font-family: "Lemonada", cursive;
                    font-size: 12px;
                    word-break: break-all;
                    color: ${colors.customColors.whiteColor};
                    padding: 0 25px;
                    font-weight: 600;

                    &:nth-of-type(1) {
                        width: 23%;
                    }

                    &:nth-of-type(2) {
                        width: 20%;
                        justify-content: center;
                    }

                    &:nth-of-type(3) {
                        width: 20%;
                        justify-content: center;
                    }

                    &:nth-of-type(4) {
                        width: 15%;
                        justify-content: center;
                    }

                    &:nth-of-type(5) {
                        width: 12%;
                        justify-content: center;
                    }

                    &:nth-of-type(6) {
                        width: 10%;
                        justify-content: center;
                    }
                }
            }

            tbody {
                position: relative;
                width: 100%;
                border: 1px solid ${colors.customColors.whiteColor2};
                border-top: none;
                border-radius: 0px 0px 10px 10px;
                display: flex;
                flex-direction: column;
                overflow: hidden;

                tr {
                    position: relative;
                    width: 100%;
                    min-height: 40px;
                    display: flex;

                    &:nth-of-type(even) {
                        background: ${colors.customColors.blueColorLight};
                    }

                    td {
                        position: relative;
                        padding: 12px 25px;
                        display: flex;
                        color: ${colors.customColors.blackColor};
                        font-size: 13px;
                        word-break: break-all;
                        line-height: 1.5;

                        &:nth-of-type(1) {
                            width: 23%;
                            display: flex;
                        }

                        &:nth-of-type(2) {
                            width: 20%;
                            align-items: center;
                            justify-content: center;
                        }

                        &:nth-of-type(3) {
                            width: 20%;
                            align-items: center;
                            justify-content: center;
                        }

                        &:nth-of-type(4) {
                            width: 15%;
                            align-items: center;
                            justify-content: center;

                            i {
                                color: ${colors.customColors.blueColor1};
                                font-size: 17px;
                                cursor: pointer;
                            }
                        }
                        &:nth-of-type(5) {
                            width: 12%;
                            align-items: center;
                            justify-content: center;

                            p {
                                position: relative;
                                font-size: 10px;
                                font-weight: 500;
                                line-height: 1;
                                display: flex;
                                align-items: center;
                                border-radius: 20px;
                                padding: 4px 15px;
                                color: ${colors.customColors.yellowColor1};
                                background: ${colors.customColors.yellowColorLight};

                                &.active {
                                    color: ${colors.customColors.greenColor};
                                    background: ${colors.customColors.greenColorLight};
                                }
                                &.deactive {
                                    color: ${colors.customColors.redColor};
                                    background: ${colors.customColors.redColorLight};
                                }
                            }
                        }

                        &:nth-of-type(6) {
                            width: 10%;
                            align-items: center;
                            justify-content: center;

                            a {
                                position: relative;
                                text-decoration: none;
                                cursor: pointer;
                                font-size: 13px;

                               &.edit_btn {
                                    color: ${colors.customColors.greenColor};
                                    margin-right: 10px;
                               }

                               &.delete_btn {
                                    color: ${colors.customColors.redColor};
                               }
                            }
                        }

                        &.empty_message {
                            position: relative;
                            width: 100%;
                            padding: 12px 25px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            font-size: 13px;
                            color: ${colors.customColors.blackColor2};
                        }
                    }
                }
            }
        }
    }
`;

export const VehicleRoutesWrapper = styled('div')`
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;

    .head_sec {
        position: relative;
        width: 100%;
        display: flex;
        align-items: center;
        padding: 0 15px;

        h6 {
            position: relative;
            font-size: 21px;
            font-weight: 600;
            color: ${colors.customColors.blackColor};
            font-family: "SUSE", sans-serif;
        }

        .filter_search_sec {
            position: relative;
            display: flex;
            align-items: center;
            margin-left: auto;

            .search_sec {
                position: relative;
                height: 35px;
                padding: 5px 0;
                display: flex;
                border: 1px solid ${colors.customColors.borderColor};
                border-radius: 6px;

                i {
                    position: relative;
                    width: 40px;
                    height: 100%;
                    font-size: 13px;
                    color: ${colors.customColors.blackColor3};
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-right: 1px solid ${colors.customColors.borderColor};
                }

                input {
                    position: relative;
                    width: 300px;
                    height: 100%;
                    border: none;
                    outline: none;
                    padding: 0 15px;
                    font-size: 12px;
                    color: ${colors.customColors.blackColor1};
                }
            }

            .add_btn {
                position: relative;
                margin-left: 20px;

                button {
                    position: relative;
                    padding: 0 35px;
                    height: 35px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    background: linear-gradient(45deg, ${colors.customColors.blueColor1}, ${colors.customColors.blueColor3});
                    border: none;
                    color: ${colors.customColors.whiteColor};
                    border-radius: 6px;
                    font-size: 13px;
                    font-weight: 500;
                    transition: all 0.5s ease;

                    i {
                        margin-right: 8px;
                        font-size: 12px;
                    }

                    &:hover {
                        border-radius: 25px;
                        transition: all 0.5s ease;
                    }
                }
            }
        }
    }

    .table_sec {
        position: relative;
        width: 100%;
        margin-top: 25px;
        padding:  0 15px;

        table {
            position: relative;
            width: 100%;
            display: flex;
            flex-direction: column;

            thead {
                position: relative;
                width: 100%;
                height: 40px;
                background: ${colors.themeColor};
                border-radius: 10px 10px 0px 0px;
                border: 1px solid ${colors.themeColor};

                tr {
                    position: relative;
                    width: 100%;
                    height: 100%;
                    display: flex;
                }

                th {
                    position: relative;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    font-family: "Lemonada", cursive;
                    font-size: 12px;
                    word-break: break-all;
                    color: ${colors.customColors.whiteColor};
                    padding: 0 25px;
                    font-weight: 600;

                    &:nth-of-type(1) {
                        width: 15%;
                    }

                    &:nth-of-type(2) {
                        width: 20%;
                        justify-content: center;
                    }
                    &:nth-of-type(3) {
                        width: 15%;
                        justify-content: center;
                    }

                    &:nth-of-type(4) {
                        width: 25%;
                        justify-content: center;
                    }

                    &:nth-of-type(5) {
                        width: 15%;
                        justify-content: center;
                    }

                    &:nth-of-type(6) {
                        width: 10%;
                        justify-content: center;
                    }
                }
            }

            tbody {
                position: relative;
                width: 100%;
                border: 1px solid ${colors.customColors.whiteColor2};
                border-top: none;
                border-radius: 0px 0px 10px 10px;
                display: flex;
                flex-direction: column;
                overflow: hidden;

                tr {
                    position: relative;
                    width: 100%;
                    min-height: 40px;
                    display: flex;

                    &:nth-of-type(even) {
                        background: ${colors.customColors.blueColorLight};
                    }

                    td {
                        position: relative;
                        padding: 12px 25px;
                        display: flex;
                        color: ${colors.customColors.blackColor};
                        font-size: 13px;
                        word-break: break-all;
                        line-height: 1.5;

                        &:nth-of-type(1) {
                            width: 15%;
                            display: flex;
                        }

                        &:nth-of-type(2) {
                            width: 20%;
                            align-items: center;
                            justify-content: center;
                        }
                        &:nth-of-type(3) {
                            width: 15%;
                            align-items: center;
                            justify-content: center;
                        }

                        &:nth-of-type(4) {
                            width: 25%;
                            align-items: center;
                            justify-content: center;

                            .name_sec {
                                position: relative;
                                width: 100%;
                                display: flex;
                                align-items: center;
                                justify-content: center;

                                p {
                                    font-size: 12px;
                                    color: ${colors.customColors.blackColor1};
                                }

                                span {
                                    font-size: 10px;
                                    color: ${colors.customColors.blackColor2};
                                    border-radius: 50%;
                                    padding: 6px;
                                    margin-left: 5px;
                                    background: ${colors.customColors.lightBackground2};
                                }
                            }
                        }

                        &:nth-of-type(5) {
                            width: 15%;
                            align-items: center;
                            justify-content: center;
                        }

                        &:nth-of-type(6) {
                            width: 10%;
                            align-items: center;
                            justify-content: center;

                            a {
                                position: relative;
                                text-decoration: none;
                                cursor: pointer;
                                font-size: 13px;

                               &.edit_btn {
                                    color: ${colors.customColors.greenColor};
                                    margin-right: 10px;
                               }

                               &.delete_btn {
                                    color: ${colors.customColors.redColor};
                               }
                            }
                        }

                        &.empty_message {
                            position: relative;
                            width: 100%;
                            padding: 12px 25px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            font-size: 13px;
                            color: ${colors.customColors.blackColor2};
                        }
                    }
                }
            }
        }
    }
`;

export const StopagesWrapper = styled('div')`
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;

    .head_sec {
        position: relative;
        width: 100%;
        display: flex;
        align-items: center;
        padding: 0 15px;

        h6 {
            position: relative;
            font-size: 21px;
            font-weight: 600;
            color: ${colors.customColors.blackColor};
            font-family: "SUSE", sans-serif;
        }

        .filter_search_sec {
            position: relative;
            display: flex;
            align-items: center;
            margin-left: auto;

            .search_sec {
                position: relative;
                height: 35px;
                padding: 5px 0;
                display: flex;
                border: 1px solid ${colors.customColors.borderColor};
                border-radius: 6px;

                i {
                    position: relative;
                    width: 40px;
                    height: 100%;
                    font-size: 13px;
                    color: ${colors.customColors.blackColor3};
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-right: 1px solid ${colors.customColors.borderColor};
                }

                input {
                    position: relative;
                    width: 300px;
                    height: 100%;
                    border: none;
                    outline: none;
                    padding: 0 15px;
                    font-size: 12px;
                    color: ${colors.customColors.blackColor1};
                }
            }

            .add_btn {
                position: relative;
                margin-left: 20px;

                button {
                    position: relative;
                    padding: 0 35px;
                    height: 35px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    background: linear-gradient(45deg, ${colors.customColors.blueColor1}, ${colors.customColors.blueColor3});
                    border: none;
                    color: ${colors.customColors.whiteColor};
                    border-radius: 6px;
                    font-size: 13px;
                    font-weight: 500;
                    transition: all 0.5s ease;

                    i {
                        margin-right: 8px;
                        font-size: 12px;
                    }

                    &:hover {
                        border-radius: 25px;
                        transition: all 0.5s ease;
                    }
                }
            }
        }
    }

    .table_sec {
        position: relative;
        width: 100%;
        margin-top: 25px;
        padding:  0 15px;

        table {
            position: relative;
            width: 100%;
            display: flex;
            flex-direction: column;

            thead {
                position: relative;
                width: 100%;
                height: 40px;
                background: ${colors.themeColor};
                border-radius: 10px 10px 0px 0px;
                border: 1px solid ${colors.themeColor};

                tr {
                    position: relative;
                    width: 100%;
                    height: 100%;
                    display: flex;
                }

                th {
                    position: relative;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    font-family: "Lemonada", cursive;
                    font-size: 12px;
                    word-break: break-all;
                    color: ${colors.customColors.whiteColor};
                    padding: 0 25px;
                    font-weight: 600;

                    &:nth-of-type(1) {
                        width: 20%;
                    }

                    &:nth-of-type(2) {
                        width: 28%;
                    }

                    &:nth-of-type(3) {
                        width: 15%;
                        justify-content: center;
                    }

                    &:nth-of-type(4) {
                        width: 15%;
                        justify-content: center;
                    }

                    &:nth-of-type(5) {
                        width: 10%;
                        justify-content: center;
                    }

                    &:nth-of-type(6) {
                        width: 10%;
                        justify-content: center;
                    }
                }
            }

            tbody {
                position: relative;
                width: 100%;
                border: 1px solid ${colors.customColors.whiteColor2};
                border-top: none;
                border-radius: 0px 0px 10px 10px;
                display: flex;
                flex-direction: column;
                overflow: hidden;

                tr {
                    position: relative;
                    width: 100%;
                    min-height: 40px;
                    display: flex;

                    &:nth-of-type(even) {
                        background: ${colors.customColors.blueColorLight};
                    }

                    td {
                        position: relative;
                        padding: 12px 25px;
                        display: flex;
                        color: ${colors.customColors.blackColor};
                        font-size: 13px;
                        word-break: break-all;
                        line-height: 1.5;

                        &:nth-of-type(1) {
                            width: 20%;
                            display: flex;
                        }

                        &:nth-of-type(2) {
                            width: 28%;
                            align-items: center;
                        }

                        &:nth-of-type(3) {
                            width: 15%;
                            justify-content: center;
                        }

                        &:nth-of-type(4) {
                            width: 15%;
                            justify-content: center;
                        }

                        &:nth-of-type(4) {
                            width: 15%;
                            justify-content: center;
                        }

                        &:nth-of-type(5) {
                            width: 10%;
                            align-items: flex-start;
                            justify-content: center;

                            p {
                                position: relative;
                                font-size: 10px;
                                font-weight: 500;
                                line-height: 1;
                                display: flex;
                                align-items: center;
                                border-radius: 20px;
                                padding: 4px 15px;
                                color: ${colors.customColors.yellowColor1};
                                background: ${colors.customColors.yellowColorLight};

                                &.active {
                                    color: ${colors.customColors.greenColor};
                                    background: ${colors.customColors.greenColorLight};
                                }
                            }
                        }

                        &:nth-of-type(6) {
                            width: 10%;
                            justify-content: center;

                            a {
                                position: relative;
                                text-decoration: none;
                                cursor: pointer;
                                font-size: 13px;

                               &.edit_btn {
                                    color: ${colors.customColors.greenColor};
                                    margin-right: 10px;
                               }

                               &.delete_btn {
                                    color: ${colors.customColors.redColor};
                               }
                            }
                        }

                        &.empty_message {
                            position: relative;
                            width: 100%;
                            padding: 12px 25px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            font-size: 13px;
                            color: ${colors.customColors.blackColor2};
                        }
                    }
                }
            }
        }
    }
`;

export const AddRoutesWrapper = styled('div')`
    .route_save_btn {
        margin-left: auto; display: flex; align-items: center; justify-content: center; gap: 7px;
        min-width: 110px; height: 34px; padding: 0 20px; border: none; border-radius: 6px;
        background: linear-gradient(45deg, ${colors.customColors.blueColor1}, ${colors.customColors.blueColor3});
        color: ${colors.customColors.whiteColor}; font-size: 12px; font-weight: 500; cursor: pointer;
        &:hover { filter: brightness(0.96); }
        &:focus-visible { outline: 2px solid ${colors.customColors.blueColor2}; outline-offset: 3px; }
        &:disabled { cursor: not-allowed; opacity: 0.4; }
    }
    .route_timing_guide { margin: 0 15px 18px; }
    .timing_guide_heading {
        display: flex; flex-wrap: wrap; align-items: center; gap: 5px 12px; margin-bottom: 10px;
        > span { display: flex; align-items: center; gap: 7px; font-size: 12px; font-weight: 600; color: ${colors.customColors.blackColor1}; }
        i { color: ${colors.customColors.blueColor2}; }
        p { font-size: 10px; color: ${colors.customColors.blackColor2}; }
    }
    .timing_guide_grid {
        display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px;
        @media (max-width: 900px) { grid-template-columns: 1fr; }
    }
    .timing_guide_card {
        border: 1px solid #e2e9ee; border-radius: 8px; padding: 12px 14px; background: #f8fafc;
        h3 { display: flex; align-items: center; flex-wrap: wrap; gap: 7px; margin-bottom: 10px; font-size: 12px; font-weight: 600; color: #344b60; }
        h3 > span { margin-left: auto; font-size: 9px; font-weight: 400; color: #71808c; }
        h3 > i { font-size: 11px; color: #4f7e9e; }
        ul { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 9px 14px; list-style: none; padding: 0; margin: 0; }
        li { display: flex; flex-direction: column; gap: 2px; }
        li > span { font-size: 10px; color: #7a858e; }
        li > strong { font-size: 11px; font-weight: 500; color: #3c4b56; }
        .departure_rule { grid-column: 1 / -1; }
        &.dropoff { background: #f8fbf9; border-color: #e2ebe5; h3, h3 > i { color: #48745b; } }
    }
    .timing_note {
        padding: 0 15px;
        margin-bottom: 10px;
        font-size: 12px;
        line-height: 1.5;
        color: ${colors.customColors.blackColor2};
    }

    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;

    .page_items {
        position: relative;
        width: 100%;
        display: flex;

        .left_items {
            position: relative;
            width: calc(100% - 350px);
            height: calc(100vh - 130px);
            display: flex;
            overflow-y: auto;
            scrollbar-width: none;
            -ms-overflow-style: none;

            &::-webkit-scrollbar {
                display: none;
            }

            .item_inner {
                position: relative;
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;

                .page_head {
                    position: relative;
                    width: 100%;
                    display: flex;
                    align-items: center;
                    padding: 10px 15px;

                    .icon {
                        position: relative;
                        margin-right: 15px;
                        width: 30px;
                        height: 30px;
                        border-radius: 50%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        cursor: pointer;
                        box-shadow: 0 0 5px ${colors.boxShadowColors.shadowColor1};

                        i {
                            position: relative;
                            font-size: 14px;
                            color: ${colors.customColors.blackColor2};
                        }
                    }

                    h2 {
                        position: relative;
                        font-size: 21px;
                        font-weight: 600;
                        color: ${colors.customColors.blackColor};
                        font-family: "SUSE", sans-serif;
                    }
                }

                .top_sec {
                    position: relative;
                    width: 100%;
                    display: flex;
                    flex-wrap: wrap;
                    padding: 0 7px;
                    margin-top: 20px;

                    .input_box {
                        position: relative;
                        width: 33.33%;
                        margin-bottom: 10px;
                        padding: 0 8px;

                        input {
                            position: relative;
                            width: 100%;
                            height: 37px;
                            font-size: 12px;
                            border-radius: 5px;
                            padding: 5px 15px;
                            outline: none;
                            border: none;
                            margin-top: 3px;
                            background: ${colors.customColors.lightBackground3};
                        }

                        span {
                            position: relative;
                            display: flex;
                            align-items: center;
                            font-size: 12px;
                            font-weight: 400;
                            color: ${colors.customColors.blackColor2};

                            p {
                                color: ${colors.customColors.redColor};
                                margin-left: 2px;
                            }
                        }
                    }

                    .select_box {
                        position: relative;
                        width: 33.33%;
                        margin-bottom: 10px;
                        padding: 0 8px;

                        span {
                            position: relative;
                            display: flex;
                            align-items: center;
                            font-size: 12px;
                            font-weight: 400;
                            color: ${colors.customColors.blackColor2};

                            p {
                                color: ${colors.customColors.redColor};
                                margin-left: 2px;
                            }
                        }

                        .dropdown_sec {
                            position: relative;
                            width: 100%;
                            height: 37px;
                            flex-direction: column;
                            margin-top: 3px;

                            .dropdown_btn {
                                position: relative;
                                width: 100%;
                                height: 100%;
                                display: flex;
                                align-items: center;
                                border-radius: 5px;
                                padding: 5px 15px;
                                cursor: pointer;
                                background: ${colors.customColors.lightBackground3};

                                p {
                                    position: relative;
                                    width: calc(100% - 25px);
                                    display: flex;
                                    font-size: 12px;
                                    color: ${colors.customColors.blackColor1};
                                }

                                i {
                                    position: relative;
                                    margin-left: auto;
                                    display: flex;
                                    justify-content: flex-end;
                                    cursor: pointer;
                                    font-size: 12px;
                                    color: ${colors.customColors.blackColor2};
                                    transition: all 0.5s ease;
                                    
                                    &.active {
                                        transform: rotate(-180deg);
                                        transition: all 0.5s ease;
                                    }
                                }
                            }

                            .dropdown {
                                position: absolute;
                                top: 100%;
                                left: 0px;
                                width: 100%;
                                z-index: 15;
                                background: ${colors.customColors.whiteColor};
                                border-radius: 5px;
                                box-shadow: 5px 8px 15px ${colors.boxShadowColors.shadowColor1};
                                max-height: 0px;
                                overflow: hidden;
                                transition: all 0.5s ease;

                                &.active {
                                    max-height: 200px;
                                    transition: all 0.5s ease;
                                }

                                &.staff_dropdown {
                                    max-height: inherit;
                                    height: 0;
                                    &.active {
                                        max-height: inherit;
                                        height: max-content;
                                    }

                                    .dropdown_inner {
                                        padding: 8px;
                                    }
                                }

                                .dropdown_inner {
                                    position: relative;
                                    width: 100%;
                                    padding: 10px;
                                    display: flex;
                                    flex-direction: column;

                                    .search_sec {
                                        position: relative;
                                        height: 32px;
                                        padding: 5px 0;
                                        display: flex;
                                        border: 1px solid ${colors.customColors.borderColor};
                                        border-radius: 6px;
                                        margin-bottom: 10px;

                                        i {
                                            position: relative;
                                            width: 40px;
                                            height: 100%;
                                            font-size: 12px;
                                            color: ${colors.customColors.blackColor3};
                                            display: flex;
                                            align-items: center;
                                            justify-content: center;
                                            border-right: 1px solid ${colors.customColors.borderColor};
                                        }

                                        input {
                                            position: relative;
                                            width: 100%;
                                            height: 100%;
                                            border: none;
                                            outline: none;
                                            padding: 0 15px;
                                            font-size: 10px;
                                            color: ${colors.customColors.blackColor1};
                                        }
                                    }

                                    ul {
                                        position: relative;
                                        width: 100%;
                                        display: flex;
                                        flex-direction: column;
                                        max-height: 160px;
                                        overflow-y: auto;
                                        scrollbar-width: none;
                                        -ms-overflow-style: none;

                                        &::-webkit-scrollbar {
                                            display: none;
                                        }

                                        li {
                                            position: relative;
                                            width: 100%;
                                            list-style: none;
                                            padding: 7px 15px;
                                            cursor: pointer;
                                            font-size: 12px;
                                            color: ${colors.customColors.blackColor1};
                                            border-radius: 4px;
                                            transition: all 0.5s ease;

                                            &:hover {
                                                background: ${colors.themeColor};
                                                color: ${colors.customColors.whiteColor};
                                                transition: all 0.5s ease;
                                            }

                                            &.active {
                                                background: ${colors.customColors.lightBackground};
                                                color: ${colors.customColors.blackColor};

                                                &:hover {
                                                    color: ${colors.customColors.blackColor};
                                                }
                                            }

                                            &.empty_message {
                                                padding: 5px 10px;
                                                color: ${colors.customColors.blackColor3};
                                                pointer-events: none;
                                            }

                                            &.vehicle_item {
                                                display: block;

                                                p {
                                                    display: inline;
                                                    margin-left: 2px;
                                                    font-size: 10px;
                                                }
                                            }
                                        }
                                    }
                                }

                                .staff_groups {
                                    position: relative;
                                    width: 100%;
                                    display: flex;
                                    flex-direction: column;
                                    gap: 8px;
                                    max-height: 230px;
                                    overflow-y: auto;
                                    scrollbar-width: none;
                                    -ms-overflow-style: none;

                                    &::-webkit-scrollbar {
                                        display: none;
                                    }

                                    .staff_group {
                                        position: relative;
                                        width: 100%;
                                        display: flex;
                                        flex-direction: column;
                                        border: 1px solid ${colors.customColors.borderColor};
                                        border-radius: 5px;

                                        .group_header {
                                            position: relative;
                                            width: 100%;
                                            display: flex;
                                            align-items: center;
                                            justify-content: space-between;
                                            padding: 6px 12px;
                                            background: ${colors.customColors.lightBackground};
                                            cursor: pointer;
                                            user-select: none;
                                            border-radius: 5px 5px 0 0;

                                            b {
                                                font-size: 11px;
                                                font-weight: 500;
                                                color: ${colors.customColors.blackColor};
                                                text-transform: capitalize;
                                                font-style: italic;
                                            }

                                            i {
                                                font-size: 11px;
                                                color: ${colors.customColors.blackColor2};
                                                transition: transform 0.3s ease;

                                                &.open {
                                                    transform: rotate(-180deg);
                                                }
                                            }
                                        }

                                        .group_list {
                                            position: relative;
                                            width: 100%;
                                            max-height: 0;
                                            overflow: hidden;
                                            transition: max-height 0.35s ease;

                                            &.open {
                                                max-height: 170px;
                                                overflow-y: auto;
                                                scrollbar-width: none;
                                                -ms-overflow-style: none;

                                                &::-webkit-scrollbar {
                                                    display: none;
                                                }
                                            }

                                            ul {
                                                position: relative;
                                                width: 100%;
                                                display: flex;
                                                flex-direction: column;
                                                padding: 5px;

                                                li {
                                                    position: relative;
                                                    width: 100%;
                                                    list-style: none;
                                                    padding: 6px 12px 6px 6px;
                                                    cursor: pointer;
                                                    font-size: 12px;
                                                    color: ${colors.customColors.blackColor1};
                                                    display: flex;
                                                    align-items: center;
                                                    gap: 8px;
                                                    transition: background 0.2s ease;

                                                    &:hover {
                                                        background: ${colors.customColors.lightBackground3};
                                                    }

                                                    &.selected {
                                                        background: ${colors.customColors.lightBackground};
                                                        color: ${colors.customColors.blackColor};
                                                    }

                                                    .check_icon {
                                                        width: 14px;
                                                        height: 14px;
                                                        border-radius: 3px;
                                                        border: 1.5px solid ${colors.customColors.blackColor3};
                                                        display: flex;
                                                        align-items: center;
                                                        justify-content: center;
                                                        flex-shrink: 0;

                                                        &.checked {
                                                            background: ${colors.themeColor};
                                                            border-color: ${colors.themeColor};

                                                            i {
                                                                font-size: 8px;
                                                                color: ${colors.customColors.whiteColor};
                                                            }
                                                        }
                                                    }

                                                    &.empty_message {
                                                        color: ${colors.customColors.blackColor3};
                                                        pointer-events: none;
                                                        font-size: 11px;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

                .institution_time_sec {
                    position: relative;
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    margin-top: 10px;
                    padding: 0 8px;

                    .head {
                        position: relative;
                        width: 100%;
                        display: flex;
                        padding: 0 8px;

                        h3 {
                            position: relative;
                            font-size: 14px;
                            color: ${colors.customColors.blackColor2};
                            font-weight: 500;
                        }
                    }

                    .time_sec_content {
                        position: relative;
                        width: 100%;
                        display: flex;
                        flex-wrap: wrap;
                        margin-top: 8px;

                        .date_box {
                            position: relative;
                            width: 50%;
                            margin-bottom: 12px;
                            padding: 0 8px;

                            span {
                                position: relative;
                                display: flex;
                                align-items: center;
                                font-size: 12px;
                                font-weight: 400;
                                color: ${colors.customColors.blackColor2};

                                p {
                                    color: ${colors.customColors.redColor};
                                    margin-left: 2px;
                                }
                            }

                            .date_btn {
                                position: relative;
                                width: 100%;
                                height: 45px;
                                display: flex;
                                align-items: center;
                                gap: 20px;
                                overflow: hidden;
                                isolation: isolate;
                                border: 1px solid rgba(255, 255, 255, 0.9);
                                border-radius: 6px;
                                padding: 10px 24px 10px 16px;
                                background: linear-gradient(115deg, #f5fbff 0%, #e9f6ff 62%, #c9eaff 100%);
                                box-shadow: 0 10px 25px rgba(40, 151, 234, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.9);
                                cursor: pointer;
                                margin-top: 6px;

                                &::before,
                                &::after {
                                    content: "";
                                    position: absolute;
                                    right: -28px;
                                    bottom: -48px;
                                    width: 190px;
                                    height: 105px;
                                    border-radius: 50%;
                                    background: rgba(69, 173, 246, 0.2);
                                    transform: rotate(-12deg);
                                    z-index: -1;
                                }

                                &::after {
                                    right: -48px;
                                    bottom: -63px;
                                    width: 215px;
                                    background: rgba(31, 149, 238, 0.17);
                                }

                                p {
                                    position: relative;
                                    width: auto;
                                    display: flex;
                                    align-items: baseline;
                                    font-size: 15px;
                                    line-height: 1;
                                    font-weight: 600;
                                    letter-spacing: 0.5px;
                                    color: #07112f;
                                    text-shadow: 0 1px 0 rgba(255, 255, 255, 0.75);
                                    z-index: 1;
                                }

                                i {
                                    position: relative;
                                    order: -1;
                                    flex: 0 0 25px;
                                    width: 25px;
                                    height: 25px;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    cursor: pointer;
                                    font-size: 13px;
                                    color: #1598f5;
                                    border: 7px solid rgba(255, 255, 255, 0.72);
                                    border-radius: 50%;
                                    background: #ffffff;
                                    box-shadow: 0 5px 14px rgba(19, 144, 235, 0.28);
                                    z-index: 1;
                                }
                            }

                            .time_dropdown {
                                position: absolute;
                                top: calc(100% + 2px);
                                left: 8px;
                                z-index: 20;
                            }
                        }
                    }
                }

                .stopage_sections {
                    position: relative;
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    margin-top: 20px;

                    .sec_head {
                        position: relative;
                        width: 100%;
                        display: flex;
                        padding: 0 15px;

                        h6 {
                            position: relative;
                            font-size: 14px;
                            font-weight: 500;
                            color: ${colors.customColors.blackColor1};
                        }
                    }

                    .sec_content {
                        position: relative;
                        width: 100%;
                        display: flex;
                        flex-direction: column;
                        padding:  0 15px;
                        
                        .content_box {
                            position: relative;
                            width: 100%;
                            display: flex;
                            border: 1px solid ${colors.customColors.borderColor};
                            border-radius: 6px;
                            margin-top: 15px;
                            z-index: 1;
                            user-select: none;
                            transition: box-shadow 0.2s ease, border-color 0.2s ease, transform 220ms ease;

                            &.dropdown_open {
                                z-index: 60;
                            }

                            .box_content {
                                position: relative;
                                width: 100%;
                                display: flex;
                                flex-direction: column;
                                padding: 15px;

                                .box_head {
                                    position: relative;
                                    width: 100%;
                                    display: flex;
                                    align-items: center;
                                    justify-content: space-between;

                                    a {
                                        position: relative;
                                        width: max-content;
                                        padding: 4px 10px;
                                        border-radius: 25px;
                                        background: ${colors.customColors.blueColor2};
                                        font-size: 11px;
                                        text-decoration: none;
                                        color: ${colors.customColors.whiteColor};
                                    }

                                    .delete_btn {
                                        position: absolute;
                                        top: -15px;
                                        right: -15px;
                                        width: 28px;
                                        height: 28px;
                                        border-radius: 0 6px 0 6px;
                                        display: flex;
                                        align-items: center;
                                        justify-content: center;
                                        cursor: pointer;
                                        background: ${colors.customColors.redColorLight};

                                        i {
                                            font-size: 11px;
                                            color: ${colors.customColors.redColor};
                                        }
                                    }
                                }

                                .box_items {
                                    position: relative;
                                    width: 100%;
                                    display: flex;
                                    flex-wrap: wrap;
                                    justify-content: space-between;
                                    margin-top: 10px;

                                    .select_box {
                                        position: relative;
                                        width: 32%;
                                        margin-bottom: 8px;
                                        z-index: 49;

                                        span {
                                            position: relative;
                                            display: flex;
                                            align-items: center;
                                            font-size: 12px;
                                            font-weight: 400;
                                            color: ${colors.customColors.blackColor2};

                                            p {
                                                color: ${colors.customColors.redColor};
                                                margin-left: 2px;
                                            }
                                        }

                                        .dropdown_sec {
                                            position: relative;
                                            width: 100%;
                                            height: 37px;
                                            flex-direction: column;
                                            margin-top: 3px;

                                            .dropdown_btn {
                                                position: relative;
                                                width: 100%;
                                                height: 100%;
                                                display: flex;
                                                align-items: center;
                                                border-radius: 5px;
                                                padding: 5px 15px;
                                                cursor: pointer;
                                                background: ${colors.customColors.lightBackground3};

                                                p {
                                                    position: relative;
                                                    width: calc(100% - 25px);
                                                    display: flex;
                                                    font-size: 12px;
                                                    color: ${colors.customColors.blackColor1};
                                                }

                                                i {
                                                    position: relative;
                                                    margin-left: auto;
                                                    display: flex;
                                                    justify-content: flex-end;
                                                    cursor: pointer;
                                                    font-size: 12px;
                                                    color: ${colors.customColors.blackColor2};
                                                    transition: all 0.5s ease;
                                                    
                                                    &.active {
                                                        transform: rotate(-180deg);
                                                        transition: all 0.5s ease;
                                                    }
                                                }
                                            }

                                            .dropdown {
                                                position: absolute;
                                                top: 100%;
                                                left: 0px;
                                                width: 100%;
                                                z-index: 15;
                                                background: ${colors.customColors.whiteColor};
                                                border-radius: 5px;
                                                box-shadow: 5px 8px 15px ${colors.boxShadowColors.shadowColor1};
                                                max-height: 0px;
                                                overflow: hidden;
                                                transition: all 0.5s ease;

                                                &.active {
                                                    max-height: 200px;
                                                    transition: all 0.5s ease;
                                                }

                                                &.drop_up {
                                                    top: auto;
                                                    bottom: 100%;
                                                    box-shadow: 5px -4px 15px ${colors.boxShadowColors.shadowColor1};
                                                }

                                                .dropdown_inner {
                                                    position: relative;
                                                    width: 100%;
                                                    padding: 10px;
                                                    display: flex;
                                                    flex-direction: column;

                                                    .search_sec {
                                                        position: relative;
                                                        height: 32px;
                                                        padding: 5px 0;
                                                        display: flex;
                                                        border: 1px solid ${colors.customColors.borderColor};
                                                        border-radius: 6px;
                                                        margin-bottom: 10px;

                                                        i {
                                                            position: relative;
                                                            width: 40px;
                                                            height: 100%;
                                                            font-size: 12px;
                                                            color: ${colors.customColors.blackColor3};
                                                            display: flex;
                                                            align-items: center;
                                                            justify-content: center;
                                                            border-right: 1px solid ${colors.customColors.borderColor};
                                                        }

                                                        input {
                                                            position: relative;
                                                            width: 100%;
                                                            height: 100%;
                                                            border: none;
                                                            outline: none;
                                                            padding: 0 15px;
                                                            font-size: 10px;
                                                            color: ${colors.customColors.blackColor1};
                                                        }
                                                    }

                                                    ul {
                                                        position: relative;
                                                        width: 100%;
                                                        display: flex;
                                                        flex-direction: column;
                                                        max-height: 135px;
                                                        overflow-y: auto;
                                                        scrollbar-width: none;
                                                        -ms-overflow-style: none;

                                                        &::-webkit-scrollbar {
                                                            display: none;
                                                        }

                                                        li {
                                                            position: relative;
                                                            width: 100%;
                                                            list-style: none;
                                                            padding: 7px 15px;
                                                            cursor: pointer;
                                                            font-size: 12px;
                                                            color: ${colors.customColors.blackColor1};
                                                            border-radius: 4px;
                                                            transition: all 0.5s ease;

                                                            &:hover {
                                                                background: ${colors.themeColor};
                                                                color: ${colors.customColors.whiteColor};
                                                                transition: all 0.5s ease;
                                                            }

                                                            &.active {
                                                                background: ${colors.customColors.lightBackground};
                                                                color: ${colors.customColors.blackColor};

                                                                &:hover {
                                                                    color: ${colors.customColors.blackColor};
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }

                                    .date_box {
                                        position: relative;
                                        width: 32%;
                                        margin-bottom: 8px;

                                        span {
                                            position: relative;
                                            display: flex;
                                            align-items: center;
                                            font-size: 12px;
                                            font-weight: 400;
                                            color: ${colors.customColors.blackColor2};

                                            p {
                                                color: ${colors.customColors.redColor};
                                                margin-left: 2px;
                                            }
                                        }

                                        .date_btn {
                                            position: relative;
                                            width: 100%;
                                            height: 37px;
                                            display: flex;
                                            align-items: center;
                                            border-radius: 5px;
                                            padding: 5px 15px;
                                            background: ${colors.customColors.lightBackground3};
                                            cursor: pointer;
                                            margin-top: 3px;

                                            p {
                                                position: relative;
                                                width: calc(100% - 25px);
                                                display: flex;
                                                font-size: 12px;
                                                color: ${colors.customColors.blackColor1};
                                            }

                                            i {
                                                position: relative;
                                                width: 25px;
                                                display: flex;
                                                justify-content: flex-end;
                                                cursor: pointer;
                                                font-size: 12px;
                                                color: ${colors.customColors.blackColor2};
                                            }
                                        }
                                    }
                                }
                            }
                        }

                        .routes_button {
                            position: relative;
                            width: 100%;
                            display: flex;
                            margin-top: 20px;
                            align-items: center;

                            .add_sec {
                                position: relative;
                                width: 100%;
                                display: flex;

                                span {
                                    position: relative;
                                    padding: 7px 25px;
                                    border-radius: 8px;
                                    background: ${colors.customColors.whiteColor};
                                    font-size: 13px;
                                    border: 1px dashed ${colors.customColors.blueColor2};
                                    color: ${colors.customColors.blueColor2};
                                    font-weight: 500;
                                    cursor: pointer;

                                    i {
                                        margin-right: 5px;
                                    }
                                }
                            }

                            a {
                                position: relative;
                                width: 150px;
                                padding: 7px 0;
                                border-radius: 8px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                font-size: 13px;
                                background: linear-gradient(45deg, ${colors.customColors.blueColor1}, ${colors.customColors.blueColor3});
                                border: none;
                                color: ${colors.customColors.whiteColor};
                                font-weight: 500;
                                cursor: pointer;
                                text-decoration: none;
                                transition: all 0.5s ease;
                                
                                i {
                                    margin-right: 7px;
                                }
                                
                                &:hover {
                                    border-radius: 25px;
                                    transition: all 0.5s ease;
                                }
                            }
                        }
                        
                    }
                }

            }
        }

        .right_items {
            position: relative;
            width: 350px;
            height: calc(100vh - 130px);
            display: flex;
            padding: 10px;

            .item_inner {
                position: relative;
                width: 100%;
                height: 100%;
                display: flex;
                border-radius: 6px;
                box-shadow: 5px 5px 10px ${colors.boxShadowColors.shadowColor1},
                        -4px -4px 10px ${colors.boxShadowColors.shadowColor1};
            }
        }
    }

    .btn_sec {
        position: relative;
        width: 100%;
        display: flex;
        justify-content: flex-end;

        button {
            position: relative;
            width: 160px;
            height: 35px;
            font-size: 13px;
            font-weight: 500;
            cursor: pointer;
            border-radius: 6px;
            overflow: hidden;
            border: none;
            background: ${colors.customColors.blueColor1};
            color: ${colors.customColors.whiteColor};
            transition: all 0.5s ease;

            &:hover {
                border-radius: 25px;
                transition: all 0.5s ease;
            }
        }
    }
`;
